/**
 * Tiny CSV export helper — no external dependency.
 *
 * Usage:
 *   downloadCsv('payments-2026-05.csv', rows, [
 *     { key: 'student_name', header: 'Payer' },
 *     { key: 'amount',       header: 'Amount',   format: (v) => v.toFixed(2) },
 *   ]);
 */

const escapeCell = (val) => {
  if (val === null || val === undefined) return '';
  const str = String(val);
  // Escape per RFC 4180: wrap in quotes if cell contains quote, comma, or newline;
  // double any embedded quotes.
  if (/[",\n\r]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

export const buildCsv = (rows, columns) => {
  const header = columns.map((c) => escapeCell(c.header ?? c.key)).join(',');
  const body = rows.map((row) =>
    columns
      .map((c) => {
        const raw = row[c.key];
        const formatted = typeof c.format === 'function' ? c.format(raw, row) : raw;
        return escapeCell(formatted);
      })
      .join(',')
  );
  // BOM so Excel on Windows opens UTF-8 cleanly.
  return '\uFEFF' + [header, ...body].join('\r\n');
};

export const downloadCsv = (filename, rows, columns) => {
  const csv = buildCsv(rows, columns);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Free the object URL after the browser has had time to start the download.
  setTimeout(() => URL.revokeObjectURL(url), 1500);
};
